import type { TagsCollection } from '@racemap/utilities/functions/timing';
import type { Immutable } from 'immer';
import type { FC } from 'react';
import { FilterSelector } from '../BasicComponents/FilterSelector/FilterSelector';
import { IconFilter } from '../Icon';
import { BasicModal } from './BasicModal';
import { areTagsSelected } from './Leaderboard/Columns/TagCol';

interface Props {
  tags: TagsCollection;
  selectedTags: TagsCollection;
  onChange: (tags: Immutable<TagsCollection>) => void;
}

export const FilterModal: FC<Props> = ({ tags, selectedTags, onChange }) => {
  return (
    <BasicModal
      title="Filter:"
      buttonIcon={<IconFilter />}
      activ={areTagsSelected(selectedTags)}
      style={{ marginLeft: '5px', borderColor: '#ced4da' }}
    >
      <FilterSelector
        options={tags}
        value={selectedTags}
        onChange={onChange}
        filterZeroCounts
        showCounts
        showOptions
      />
    </BasicModal>
  );
};
